import ApiService from "../ApiService";
import RoleService from "../roles/RoleService";
import providerService from "../provider/ProviderService";

const userService = {
    getUser() {
        return ApiService.get("/user");
    },
    getUserOne(id) {
        return ApiService.get(`/user/${id}`);
    },
    createUser(items) {
        return ApiService.post("/user", items);
    },
    getRoles() {
        return RoleService.getRoles();
    },
    getProviders() {
        return providerService.getProviders();
    },
    updateUsers(id, data) {
        return ApiService.post(`/user/update?id=${id}`, data);
    },
    deleteUsers(data) {
        return ApiService.post(`/user/remove`, data);
    }
};

export default userService;